import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { Navigate } from 'react-router-dom';
import { auth } from '../firebase';
import { fetchAdminByEmail } from '../services/firestore';
import { useAdminStore } from '../store/adminStore';
import { normalizeAdminRole } from '../hooks/useAdminRole';

export default function AdminGuard({ children }) {
  const [status, setStatus] = useState('checking');
  const setProfile = useAdminStore((state) => state.setProfile);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user?.email) {
        setStatus('needs-login');
        return;
      }

      const profile = await fetchAdminByEmail(user.email);
      if (!profile) {
        setStatus('denied');
        return;
      }

      setProfile({
        email: user.email.toLowerCase(),
        ...profile,
        role: normalizeAdminRole(profile.role),
      });
      setStatus('allowed');
    });

    return unsubscribe;
  }, [setProfile]);

  if (status === 'checking') return <div className="wb-loader">Checking admin access...</div>;
  if (status === 'needs-login') return <Navigate to="/login" replace />;
  if (status === 'denied') return <Navigate to="/unauthorized" replace />;

  return children;
}
